// https://github.com/giantcz/gia
// Add import to js/components
import Component from 'gia/Component'

export default class CTAComponent extends Component {

  constructor(element) {
    super(element);
    this.ref = {
      
      links: [],

    }

    // this.settings = this.getInitialProps();
  }

  mount() { 
    document.body.classList.add('global-cta-active');
    document.documentElement.style.setProperty('--global-cta-height', this.element.offsetHeight+'px');
  }

  
}
